import React from 'react';
import Header from './Header';
import Footer from './Footer';

function Layout(props) {
  return (
    <div>
      {!props.noHeader && <Header inProgress={props.inProgress}  hideLinks={props.hideLinks} />}
      {props.children}
      {!props.noFooter && <Footer />}
    </div>
  );
}

export default Layout;